// import axios from "axios";
// const API = 'https://gx92vct4sb.execute-api.us-west-2.amazonaws.com/prod/agents' 
// export const fetchAllAgents = () => axios.get(API);



import axios from "axios";

const API = "https://qe9e83jv9f.execute-api.us-west-2.amazonaws.com/prod";
export const fetchAllAgents = (token) => {
  console.log("MAKING REQUEST WITH TOKEN: ", token)
  return axios.get(API, {
    headers: {
      authorizationToken: token,
    },
  });
};

